import { useAppSelector } from '../hooks/useAppSelector';
import { Loader } from '../components/Loader';
import { BabylonScene } from '../components/BabylonScene';
import './Layout44.css';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { setActiveState, setActiveVariant, setDisplayedChangeable } from '../slices/settingsSlice';
import { useEffect, useState } from 'react';
import { QRDialog } from '../components/QRDialog';
import { useSearchParams } from 'react-router-dom';

const AR_BUTTON_DESKTOP_ID = 'ar-button-desktop'

export function Layout44() {
  const [searchParams, setSearchParams] = useSearchParams()
  const variantDisabled = useAppSelector((state) => state.settings.variantDisabled);
  const stateDisabled = useAppSelector((state) => state.settings.stateDisabled);
  const arDisabled = useAppSelector((state) => state.settings.arDisabled);
  const animationPlaying = useAppSelector((state) => state.settings.animationPlaying);
  const states = useAppSelector((state) => state.settings.states);
  const activeFetches = useAppSelector((state) => state.settings.activeFetches);
  const language = useAppSelector((state) => state.settings.language);
  const activeState = useAppSelector((state) => state.settings.activeState);
  const arModelsPath = useAppSelector((state) => state.settings.arModelsPath);


  const [navbarClosed, setNavbarClosed] = useState(true);
  const [isModalShow, setIsModalShow] = useState(false);

  const activeVariant = useAppSelector((state) => state.settings.activeVariant);
  const changeable = useAppSelector((state) => state.settings.changeable);
  const dispatch = useAppDispatch();
  const displayedChangeable = useAppSelector((state) => state.settings.displayedChangeable);
  const variant = searchParams.get('variant');

  const isMobileDeviсe = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
  .test(navigator.userAgent);

  const onClick = () => setIsModalShow(true);

  const getActiveARButton = () => {
    if (arDisabled) return null;
    
    const parsedArButtonMobile =
      <button className="ar-button" slot="ar-button">Activate AR</button>;

    const parsedArButtonDesktop =
      <button id={AR_BUTTON_DESKTOP_ID} onClick={onClick} className="ar-button">Activate AR</button>;

    return <model-viewer
      reveal="manual"
      src={`${arModelsPath}${activeVariant.join('-')}.glb`}
      ar
      autoplay
      touch-action="pan-y"
    >
      {
        isMobileDeviсe
          ? parsedArButtonMobile
          : parsedArButtonDesktop
      }
    </model-viewer>
  }

  // Добавляем в searchParams variant, если он отсутствует
  useEffect(() => {    
    if (!variantDisabled && !variant) {
      const params = changeable.map(() => '0').join('-');
      setSearchParams((initParams) => {
        initParams.set('variant', params)
        return initParams;
      })
    }
  }, [searchParams, changeable, setSearchParams, variantDisabled, variant]);

  return (
    <>
    <div className="container">
    {getActiveARButton()}
      <div className="activity-container">
        <div className={`activity-buttons ${!navbarClosed ? 'activity-buttons-bar-opened' : ''}`}>
          {!stateDisabled ? (
            <div
              className="state-button"
              onClick={() => {
                !animationPlaying && dispatch(setActiveState((activeState + 1) % 2));
              }}
            >
              <div className={activeState ? 'state-name-disabled' : ''}>{states[0]}</div>
              <div className={`state-button-switch-background ${activeState && 'state-button-switch-background-switched'}`}>
                <div className="state-button-switch-circle"></div>
              </div>
              <div className={!activeState ? 'state-name-disabled' : ''}>{states[1]}</div>
            </div>
          ) : null}
        </div>
        <a className={`watermark-container-icon ${!navbarClosed && 'watermark-container-bar-opened'}`} href="https://immersivo.co" target="_blank" rel="noreferrer">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <g clip-path="url(#clip0_133_2)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.3998 1.42697e-05H28.9074C29.2005 0.0104505 29.4784 0.145586 29.6823 0.376842C29.8862 0.608101 30.0002 0.917332 30 1.23912V28.7609C30.0002 29.0827 29.8862 29.3919 29.6823 29.6232C29.4784 29.8544 29.2005 29.9896 28.9074 30H27.3998C27.1842 30.0012 26.9729 29.9342 26.7911 29.8071C26.6092 29.68 26.4646 29.4982 26.3744 29.2833L22.9929 21.276C22.9032 21.0621 22.7599 20.8806 22.5798 20.7528C22.3995 20.6251 22.1899 20.5563 21.9753 20.5546C21.7608 20.5528 21.5502 20.6181 21.3683 20.7429C21.1864 20.8677 21.0406 21.0468 20.9481 21.2593L17.4415 29.2967C17.3494 29.5075 17.2047 29.6854 17.0244 29.8099C16.844 29.9343 16.6352 30.0002 16.4222 30H13.5656C13.3501 30.0007 13.1389 29.9336 12.9572 29.8065C12.7754 29.6795 12.6307 29.4979 12.5402 29.2833L9.15869 21.276C9.06908 21.0621 8.92578 20.8806 8.74555 20.7528C8.56533 20.6251 8.35572 20.5563 8.14113 20.5546C7.92659 20.5528 7.71603 20.6181 7.53415 20.7429C7.35221 20.8677 7.20648 21.0468 7.11393 21.2593L3.60731 29.2967C3.51547 29.5078 3.37094 29.6859 3.19051 29.8104C3.01007 29.9349 2.80113 30.0006 2.58799 30H1.12918C0.829699 30 0.542491 29.8694 0.330726 29.6371C0.118961 29.4047 0 29.0895 0 28.7609V1.23912C0 0.910482 0.118961 0.59532 0.330726 0.362942C0.542491 0.130564 0.829699 1.42697e-05 1.12918 1.42697e-05H2.58799C2.80113 -0.000627717 3.01007 0.0651158 3.19051 0.189609C3.37094 0.314101 3.51547 0.492233 3.60731 0.703294L7.11393 8.74075C7.20648 8.95318 7.35221 9.13227 7.53415 9.25706C7.71603 9.38186 7.92659 9.44721 8.14113 9.44545C8.35572 9.44374 8.56533 9.37494 8.74555 9.24717C8.92578 9.11939 9.06908 8.93793 9.15869 8.72399L12.5402 0.716684C12.6307 0.502083 12.7754 0.320495 12.9572 0.193462C13.1389 0.0664281 13.3501 -0.000711207 13.5656 1.42697e-05H16.4222C16.6352 -0.000227973 16.844 0.065683 17.0244 0.19013C17.2047 0.314577 17.3494 0.492483 17.4415 0.703294L20.9481 8.74075C21.0406 8.95318 21.1864 9.13227 21.3683 9.25706C21.5502 9.38186 21.7608 9.44721 21.9753 9.44545C22.1899 9.44374 22.3995 9.37494 22.5798 9.24717C22.7599 9.11939 22.9032 8.93793 22.9929 8.72399L26.3744 0.716684C26.4646 0.501828 26.6092 0.320012 26.7911 0.19293C26.9729 0.0658482 27.1842 -0.00112391 27.3998 1.42697e-05ZM2.26144 21.6946C2.2615 21.9764 2.34908 22.2497 2.50974 22.4696C2.67039 22.6894 2.89454 22.8426 3.14518 22.9038C3.39583 22.9651 3.65802 22.9307 3.8885 22.8065C4.11899 22.6822 4.30399 22.4755 4.41301 22.2204L6.97661 16.2459C7.06827 16.0332 7.2129 15.8533 7.39384 15.727C7.57478 15.6008 7.78456 15.5334 7.99899 15.5326C8.21269 15.5329 8.42192 15.5998 8.60236 15.7255C8.7828 15.8512 8.92705 16.0304 9.01832 16.2425L11.6216 22.2706C11.7308 22.5263 11.9163 22.7333 12.1475 22.8575C12.3785 22.9816 12.6413 23.0155 12.8924 22.9533C13.1434 22.8912 13.3675 22.7369 13.5277 22.5159C13.6879 22.2949 13.7745 22.0205 13.7732 21.7382V18.7206C13.7732 18.7184 13.7732 18.7161 13.7732 18.7139V11.2861C13.7732 11.2839 13.7732 11.2816 13.7732 11.2794V8.26184C13.7745 7.97951 13.6879 7.70508 13.5277 7.48409C13.3675 7.2631 13.1434 7.10879 12.8924 7.04666C12.6413 6.98453 12.3785 7.01836 12.1475 7.14249C11.9163 7.26668 11.7308 7.4737 11.6216 7.72937L9.01832 13.7575C8.92705 13.9696 8.7828 14.1488 8.60236 14.2745C8.42192 14.4002 8.21269 14.4671 7.99899 14.4674C7.78456 14.4666 7.57478 14.3992 7.39384 14.273C7.2129 14.1467 7.06827 13.9668 6.97661 13.7541L4.41301 7.7796C4.30399 7.52447 4.11899 7.31775 3.8885 7.1935C3.65802 7.06925 3.39583 7.03494 3.14518 7.09621C2.89454 7.15743 2.67039 7.31059 2.50974 7.53042C2.34908 7.75026 2.2615 8.0236 2.26144 8.30538V21.6946ZM16.1903 11.2794C16.1903 11.2816 16.1903 11.2839 16.1903 11.2861V18.7139C16.1903 18.7161 16.1903 18.7184 16.1903 18.7206V22.2338C16.2831 22.4448 16.4282 22.6228 16.609 22.7473C16.7899 22.8719 16.9991 22.938 17.2126 22.938C17.4261 22.938 17.6353 22.8719 17.8161 22.7473C17.997 22.6228 18.1421 22.4448 18.235 22.2338L20.7986 16.2593C20.8899 16.0463 21.0345 15.8662 21.2155 15.7399C21.3965 15.6137 21.6065 15.5464 21.821 15.546C22.0352 15.5456 22.2451 15.6123 22.4261 15.738C22.6072 15.8637 22.7518 16.0433 22.8433 16.2559L25.4435 22.284C25.5573 22.5305 25.7428 22.7282 25.9706 22.8457C26.1985 22.9632 26.4556 22.9938 26.7011 22.9326C26.9465 22.8714 27.1663 22.7219 27.3256 22.508C27.4848 22.2939 27.5743 22.0277 27.5799 21.7516V8.24842C27.5743 7.97229 27.4848 7.70605 27.3256 7.49204C27.1663 7.2781 26.9465 7.12864 26.7011 7.06743C26.4556 7.00621 26.1985 7.03682 25.9706 7.15433C25.7428 7.27184 25.5573 7.46951 25.4435 7.71595L22.8433 13.7441C22.7518 13.9567 22.6072 14.1363 22.4261 14.262C22.2451 14.3877 22.0352 14.4544 21.821 14.454C21.6065 14.4536 21.3965 14.3863 21.2155 14.2601C21.0345 14.1338 20.8899 13.9537 20.7986 13.7407L18.235 7.76617C18.1421 7.5552 17.997 7.37721 17.8161 7.25265C17.6353 7.1281 17.4261 7.06202 17.2126 7.06202C16.9991 7.06202 16.7899 7.1281 16.609 7.25265C16.4282 7.37721 16.2831 7.5552 16.1903 7.76617V11.2794Z"
                fill="#626C66"
              />
            </g>
            <defs>
              <clipPath id="clip0_133_2">
                <rect width="30" height="30" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
        <a className={`watermark-container-text ${!navbarClosed && 'watermark-container-bar-opened'}`} href="https://immersivo.co" target="_blank" rel="noreferrer">
          {language === 'ru' ? 'Разработано IMMERSIVO' : 'Powered by IMMERSIVO'}
        </a>
        <Loader visible={Boolean(activeFetches)} />
        <BabylonScene />
        {!variantDisabled ? (
          <div
            className={`bar-button ${!navbarClosed && 'bar-button-bar-opened'}`}
            onClick={() => {
              setNavbarClosed((prev) => {
                return !prev;
              });
            }}
          >
            {language === 'ru' ? (navbarClosed ? 'показать настройки' : 'скрыть настройки') : navbarClosed ? 'show settings' : 'hide settings'}
          </div>
        ) : null}
        {!variantDisabled ? (
          <div className={navbarClosed ? 'bar-container bar-container-closed' : 'bar-container'}>
            <div className="bar-changeable">
              {changeable.map((element, index) => {
                return element.materials.length > 1 ? (
                  <div
                    key={`materialtab_${index}`}
                    className={`bar-changeable-item ${displayedChangeable === index ? 'bar-changeable-item-active' : ''}`}
                    onClick={() => {
                      dispatch(setDisplayedChangeable(index));
                    }}
                  >
                    {element.name}
                  </div>
                ) : null;
              })}
            </div>
            <div className="bar-materials">
              {changeable[displayedChangeable].names.map((element, index) => {
                return (
                  <div
                    className="bar-materials-item"
                    onClick={() => {
                      dispatch(setActiveVariant({ changeable: displayedChangeable, material: index }))
                      
                      setSearchParams((searchParams) => {
                        const params = searchParams.get('variant')?.split('-');

                        if (params && params[displayedChangeable]) {
                          params[displayedChangeable] = `${index}`;
                          searchParams.set('variant', params.join('-'))
                        }
                        
                        return searchParams;
                      })
                    }}
                  >
                    <div className={`bar-materials-item-img ${activeVariant[displayedChangeable] === index ? 'bar-materials-item-img-active' : ''}`}>
                      <img className="bar-materials-item-img-src" src={changeable[displayedChangeable].images[index]}></img>
                    </div>
                    {changeable[displayedChangeable].names[index]}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
    {isModalShow && <QRDialog onClose={() => setIsModalShow(false)} />}
    </>
  );
}
